<template>
  <!--    经销商列表编辑页-->
  <div class="signBox">
    <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商详情'}]"/>
    <div class="imgBox width" v-loading="loading">
      <div class="bannerBox">
        <div class="whiteBox">
          <div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="!isShangWei">
              <h1>经销商类型</h1>
            </div>
            <div style="margin: 0.2rem 0 0.2rem 0;" v-if="!isShangWei && guanliren == true">
              <el-radio-group v-model="radio"
                              @change="changeType">
                <el-radio-button label="国内客户"></el-radio-button>
<!--                <el-radio-button label="上海直销"></el-radio-button>-->
                <el-radio-button label="海外客户"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="margin: 0.2rem 0 0.2rem 0;" v-if="!isShangWei && guanliren == false && haiwairen == false">
              <el-radio-group v-model="radio"
                              @change="changeType">
                <el-radio-button label="国内客户"></el-radio-button>
                <el-radio-button label="上海直销"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="margin: 0.2rem 0 0.2rem 0;" v-if="!isShangWei && guanliren == false && haiwairen == true">
              <el-radio-group v-model="radio"
                              @change="changeType">
                <el-radio-button label="海外客户"></el-radio-button>
              </el-radio-group>
            </div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="!isShangWei">
              <h1>直单类型（客户性质）</h1>
            </div>
            <div style="margin-top: 5px;" v-if="!isShangWei">
              <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">*
                如果您是直单用户，请勾选下方按钮，如果不是请不要勾选！
              </div>
              <el-switch
                  @change="chooseZhiDan"
                  v-model="isZhiDan"
                  class="zhidangc"
                  active-text="是否是直单用户"
                  style="margin-bottom: 0.2rem"
                  inactive-text="">
              </el-switch>
              <el-switch
                  style="margin-left: 50px;margin-bottom: 0.2rem"
                  v-if="this.isZhiDan == true && this.agentType != '3'"
                  class="zhidangc"
                  @change="chooseGoverment"
                  v-model="isGoverment"
                  active-text="是否是政府企业/军工企业"
                  inactive-text="">
              </el-switch>
              <el-switch
                  style="margin-left: 50px;margin-bottom: 0.2rem"
                  v-model="isExpandAuthority"
                  @change="chooseAddAbroad"
                  active-text="是否开通海外下单权限"
                  v-if="this.agentType != '3'"
              >
                <!-- :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'" -->
              </el-switch>
<!--              <el-switch
                  style="margin-left: 50px;margin-bottom: 0.2rem"
                  v-model="isExpandAuthority"
                  @change="chooseDomestic"
                  active-text="是否开通国内下单权限"
                  v-if="this.agentType == '3'"
              >
                &lt;!&ndash; :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'" &ndash;&gt;
              </el-switch>-->
              <!-- <el-switch
                  v-if="this.agentType != '3'"
                  style="margin-left: 50px;margin-bottom: 0.2rem"
                  @change="chooseIsBlood"
                  v-model="isBlood"
                  active-text="是否血站专用渠道"
                  inactive-text=""></el-switch> -->
            </div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="!isShangWei">
              <h1>客户资质信息</h1>
            </div>
            <div class="signsign" v-if="!isShangWei && isShowMassage">
              <div class="h-formLine" style="margin-top:0.38rem">
                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                         ref="formLabelAlign1c"
                         :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                  <el-form-item label="公司名称" class="h-elformWrap-2" prop="customerName1">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                              :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                              placeholder="请填写完整的公司全称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="客户编码" class="h-elformWrap-2" prop="usercode">
                    <el-input disabled
                              v-model="formLabelAlign1.bscUserInfoAgentBasic.usercode"
                              placeholder=""></el-input>
                  </el-form-item>
                  <el-form-item label="客户" v-if="this.agentType != '3'" class="h-elformWrap-2" prop="scale">
                    <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.scale"
                               placeholder="请选择">
                      <el-option label="小规模经营者" value="0"></el-option>
                      <el-option label="一般纳税人" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="公司地址" class="h-elformWrap-2" prop="companyAddress">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                              :title="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                              placeholder="请填写详细的公司地址"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="传真" class="h-elformWrap-2" prop="faxNumber" >
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.faxNumber"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.email"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="公司性质" v-if="this.agentType != '3'" class="h-elformWrap-2" prop="companytype">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.companytype"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="成立时间" class="h-elformWrap-2" prop="founded">
                    <el-date-picker
                        v-model="formLabelAlign1.bscUserInfoAgentBasic.founded"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="注册资金" class="h-elformWrap-2" prop="regmoney">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.regmoney"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="法人代表" class="h-elformWrap-2" prop="legal">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.legal"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="公司简介" class="h-elformWrap-2" prop="introduce">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.introduce"
                              maxlength="70"
                              placeholder="请填写详细的公司简介"></el-input>
                  </el-form-item>
                  <el-form-item label="主营业务" class="h-elformWrap-2" prop="business">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.business"
                              placeholder="请填写详细的主营业务"></el-input>
                  </el-form-item>
                  <el-form-item label="年度营业规模(万元)" class="h-elformWrap-2" prop="achievement">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.achievement"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="主要用户资源" class="h-elformWrap-2" prop="resource">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.resource"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.name1"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人手机号" class="h-elformWrap-2" prop="contactMobilePhone">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="所在国家" class="h-elformWrap-2" prop="country">
                    <brselectlazy category="YLCountry_agent"
                                  :showcode="true"
                                  :v="formLabelAlign1.bscUserInfoAgentBasic.country"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.country"
                                  :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="所在地区" class="h-elformWrap-2" prop="region"
                                v-if="this.isShowMassage !== true ? false:true && this.agentType != '3'">
                    <brselectlazy category="YLRegion"
                                  :v="formLabelAlign1.bscUserInfoAgentBasic.region"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.region"
                                  :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="所在城市" class="h-elformWrap-2" prop="contactCity" v-if="this.isShowMassage !== true ? false:true && this.agentType != '3'">
                    <el-select
                        filterable
                        v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity"
                        placeholder="请选择">
                      <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="是否国内贸易公司" v-if="this.agentType == '3'" class="h-elformWrap-2" prop="isTrade">
                    <brselectlazy category="shifou_keyong"  @input="changeTrade"
                                  :v="formLabelAlign1.bscUserInfoAgentBasic.isTrade"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.isTrade"
                                  :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="备注" v-if="this.agentType == '3'" class="h-elformWrap-2">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.remark"
                              placeholder="请填写"
                              :clearable="true"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div class="signsign" v-if="!isShowMassage">
              <div class="h-formLine" style="margin-top:0.38rem">
                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                         ref="formLabelAlign1c"
                         :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                  <el-form-item label="公司名称" class="h-elformWrap-2" prop="customerName1">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                              :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                              placeholder="请填写完整的公司全称"></el-input>
                  </el-form-item>
                  <el-form-item label="客户" v-if="this.agentType == '3'&&isShowByHw" class="h-elformWrap-2" prop="scale">
                    <el-select
                        v-model="formLabelAlign1.bscUserInfoAgentBasic.scale"
                        :class="{'ljjSelectdisabled':this.flag==='2'||this.flag==='3'||this.flag==='4'}"
                        :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请选择'"
                    >
                      <el-option label="小规模经营者" value="0"></el-option>
                      <el-option label="一般纳税人" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="公司性质" v-if="this.agentType == '3'&&isShowByHw" class="h-elformWrap-2" prop="companytype">
                    <el-input
                        v-model="formLabelAlign1.bscUserInfoAgentBasic.companytype"
                        :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"></el-input>
                  </el-form-item>
                  <el-form-item label="所在国家" class="h-elformWrap-2" prop="country">
                    <brselectlazy :showcode="true" category="YLCountry_agent"
                                  :v="formLabelAlign1.bscUserInfoAgentBasic.country"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.country"
                                  :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="所在地区" class="h-elformWrap-2" prop="region"
                                v-if="this.agentType == '3'&&isShowByHw">
                    <brselectlazy category="YLRegion"
                                  :v="formLabelAlign1.bscUserInfoAgentBasic.region"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.region"
                                  :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="所在城市" class="h-elformWrap-2" prop="contactCity"  v-if="this.agentType == '3'&&isShowByHw">
                    <el-select
                        filterable
                        v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity"
                        :class="{'ljjSelectdisabled':this.flag==='2'||this.flag==='3'||this.flag==='4'}"
                        :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请选择'"
                    >
                      <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="公司地址" class="h-elformWrap-2" prop="companyAddress">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                              :title="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                              placeholder="请填写详细的公司地址"></el-input>
                  </el-form-item>
                  <!-- <el-form-item label="是否国内贸易公司" class="h-elformWrap-2" prop="isTrade">
                      <brselectlazy category="shifou_keyong"  @input="changeTrade"
                                  :v="formLabelAlign1.bscUserInfoAgentBasic.isTrade"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.isTrade"
                                  :clearable="true"/>
                  </el-form-item> -->
                  <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.name1"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人手机号" class="h-elformWrap-2" prop="contactMobilePhone">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.email"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="关联公司" class="h-elformWrap-2" prop="associatedCompanyName" >
                    <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName"
                               :title="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName"
                               remote filterable
                               :readonly="this.flag==='3'|| this.radio == '海外客户' || this.isExpandAuthority == '1'"
                               :filter-method="showAssociationAgent" clearable  placeholder="请输入"
                               :remote-method="showAssociationAgent" @change="changeAssociationAgent($event)" >
                      <el-option v-for="(item) in associatedCompanyList"
                                 :key="item.username"
                                 :label="item.username"
                                 :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="关联公司编码" class="h-elformWrap-2" prop="associatedCompanyCode">
                    <el-input :readonly="this.flag==='3' || this.radio == '海外客户' || this.isExpandAuthority == '1'"
                              v-model="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode"
                              disabled></el-input>
                  </el-form-item>
                  <el-form-item label="备注" v-if="this.agentType == '3'" class="h-elformWrap-2">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.remark"
                              placeholder="请填写"
                              :clearable="true"></el-input>
                  </el-form-item>
                  <el-form-item label="客户" v-if="this.agentType != '3'" class="h-elformWrap-2" prop="scale">
                    <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.scale"
                               placeholder="请选择">
                      <el-option label="小规模经营者" value="0"></el-option>
                      <el-option label="一般纳税人" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="传真" class="h-elformWrap-2" prop="faxNumber" v-if="isShowByHw">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.faxNumber"
                              placeholder="请填写"></el-input>
                  </el-form-item>

                  <el-form-item label="成立时间" class="h-elformWrap-2" prop="founded" v-if="isShowByHw">
                    <el-date-picker
                        v-model="formLabelAlign1.bscUserInfoAgentBasic.founded"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="注册资金" class="h-elformWrap-2" prop="regmoney" v-if="isShowByHw">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.regmoney"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="法人代表" class="h-elformWrap-2" prop="legal" v-if="isShowByHw">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.legal"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="公司简介" class="h-elformWrap-2" prop="introduce" v-if="isShowByHw">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.introduce"
                              maxlength="70"
                              placeholder="请填写详细的公司简介"></el-input>
                  </el-form-item>
                  <el-form-item label="主营业务" class="h-elformWrap-2" prop="business" v-if="isShowByHw">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.business"
                              placeholder="请填写详细的主营业务"></el-input>
                  </el-form-item>
                  <el-form-item label="主要业绩" class="h-elformWrap-2" prop="achievement" v-if="isShowByHw">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.achievement"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="主要用户资源" class="h-elformWrap-2" prop="resource" v-if="isShowByHw">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.resource"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
              <h1>开票信息</h1>
              <span style="font-size: 14px;color: #a8a8a8;margin-left:19px;font-weight: normal;">凡是贵公司相关信息的变更请及时通知，以便及时调整，保证开票信息无误</span>
            </div>
            <div class="signsign">
              <div class="h-formLine" style="margin-top:0.38rem">
                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                         ref="formLabelAlign1d"
                         :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                  <el-form-item label="客户名称" class="h-elformWrap-2" prop="customerName1" v-if="isShowByHw &&  this.agentType != '3'"
                                :class="{'gccolor':userName1}">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                              :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="开票电话" class="h-elformWrap-2" prop="phoneNumber"
                                :class="{'gccolor':phoneNumber}">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.phoneNumber"
                              placeholder="请填写">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="开票地址" class="h-elformWrap-2" prop="cityStreetRoom"
                                :class="{'gccolor':cityStreetRoom}">
                    <el-input clearable
                              :title="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"
                              v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"
                              placeholder="请填写">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="taxCode"
                                :class="{'gccolor':taxCode}"  :required="this.isShowByHw">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.taxCode"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                </el-form>
                <el-form :model="formLabelAlign1.bscUserInfoAgentBank" label-position="right"
                         ref="formLabelAlign1e"  :required="this.isShowByHw"
                         :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                  <el-form-item
                      :class="{'gccolor':bankBranchCode}"
                      label="银行编号"
                      class="h-elformWrap-2" prop="bankBranchCode">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item
                      :class="{'gccolor':bankName}"
                      label="银行名称"
                      class="h-elformWrap-2"
                      :required="this.isShowByHw"
                      prop="bankName">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBank.bankName"
                              :title="formLabelAlign1.bscUserInfoAgentBank.bankName"
                              placeholder="请填写"></el-input>
                  </el-form-item>
                  <el-form-item label="银行账户号" class="h-elformWrap-2" :class="{'gccolor':accountHolderName}"
                                prop="accountHolderName"  :required="this.isShowByHw"
                               >
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentBank.accountHolderName"
                              placeholder="请填写"
                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="银行所属国家" class="h-elformWrap-2" :class="{'gccolor':bankCountry}"
                                prop="bankCountry"   :required="this.isShowByHw">
                    <brselectlazy category="YLCountry_agent"
                                  :v="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
                                  v-model="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
                                  :clearable="true"/>
                  </el-form-item>
                </el-form>
                <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                         ref="formLabelAlign1f"
                         :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                  <el-form-item label="发票类型" class="h-elformWrap-2" prop="customerGroup1"
                                :class="{'gccolor':customerGroup1}" :required="this.isShowByHw">
                    <el-select placeholder="请选择"
                               v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup1">
                      <el-option label="增值税发票" value="01"></el-option>
                      <el-option label="普通发票" value="02"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="国际贸易条件" class="h-elformWrap-2" prop="intCommercialTerms"
                                v-if="!isShowMassage || this.radio == '海外客户' || this.isExpandAuthority == true">
                    <brselectlazy category="YlCommercialTerms" :showcode="true"
                                  :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms"
                                  v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms"
                                  :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="国际贸易条件2" class="h-elformWrap-2" prop="intCommercialTerms2"
                                v-if="!isShowMassage || this.radio == '海外客户' || this.isExpandAuthority == true">
                    <brselectlazy category="YlCommercialTerms" :showcode="true"
                                  :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2"
                                  v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2"
                                  :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="货币种类"   class="h-elformWrap-2" prop="currencyCode">
                    <brselectlazy category="YLCurrency" :v="formLabelAlign1.bscUserInfoAgentSell.currencyCode"
                                  v-model="formLabelAlign1.bscUserInfoAgentSell.currencyCode" :clearable="true"/>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;" v-if="isShowByHw&&agentType!=3||agentType==3&&isExpandAuthority?true:false">
              <h1>邮寄发票信息</h1>
            </div>
            <div class="signsign" v-if="isShowByHw&&agentType!=3||agentType==3&&isExpandAuthority?true:false">
              <div class="h-formLine" style="margin-top:0.38rem">
                <el-form :model="formLabelAlign1.bscUserInfoAgentCompany" label-position="right"
                         ref="formLabelAlign1h"
                         :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                  <el-form-item label="邮寄接收人" class="h-elformWrap-2" prop="mailreceiver" :class="{'gccolor':mailreceiver}">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentCompany.mailreceiver"
                              placeholder="请填写">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="电话" class="h-elformWrap-2" prop="receiverphone" :class="{'gccolor':receiverphone}">
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentCompany.receiverphone"
                              placeholder="请填写">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="选择邮寄地址" class="h-elformWrap-2" prop="mailaddress" :class="{'gccolor':mailaddress}">
                    <el-input clearable
                              :title="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"
                              v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress">
                      <i
                          v-show="this.flag!=='2'&&this.flag!=='3'&&this.flag!=='4'"
                          class="el-icon-edit el-input__icon"
                          slot="suffix"
                          @click="handleIconClick">
                      </i>
                    </el-input>
                  </el-form-item>
                </el-form>

              </div>
            </div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="!isShangWei">
              <h1>上传附件</h1>
            </div>
            <div class="h-formLine weekplandetail10" v-if="!isShangWei">
              <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                       ref="formLabelAlign1i"
                       :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                <el-form-item label="委托汇款的附件" class="h-elformWrap-2" prop="upload7" v-if="have2 && (this.agentType == '3'||agentType != 3 && isExpandAuthority)">
                  <brupload
                      v-model="formLabelAlign1.bscUserInfoAgentBasic.upload5"
                      v-if="fileShowFlag"
                      :refid="refid"
                      reftype="代理商注册-委托汇款的附件"
                      :uploadflag="true"
                      :delflag="true"
                      @filecallback="fileBack1"
                      :showtime="false">
                  </brupload>
                </el-form-item>
                <el-form-item label="企业营业执照" class="h-elformWrap-2" prop="upload" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                  <brupload
                      v-if="fileShowFlag"
                      :refid="refid"
                      reftype="代理商注册-企业营业执照"
                      :uploadflag="uploadflag||agentType==3&&isExpandAuthority?true:false"
                      :delflag="delflag"
                      :showtime="false">
                  </brupload>
                </el-form-item>
                <el-form-item label="银行开户证明" class="h-elformWrap-2" prop="upload" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                  <brupload
                      v-if="fileShowFlag"
                      :refid="refid"
                      reftype="代理商注册-银行开户证明"
                      :uploadflag="uploadflag||agentType==3&&isExpandAuthority?true:false"
                      :delflag="delflag"
                      :showtime="false">
                  </brupload>
                </el-form-item>
                <el-form-item label="企业营业执照有效截止日期" class="h-elformWrap-2" prop="yyzzEffectiveDate"
                              v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                  <el-date-picker
                      style="width: 180px"  v-if="fileShowFlag"
                      v-model="formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate"
                      type="date"
                      placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="法人身份证" class="h-elformWrap-2" prop="upload" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                  <brupload
                      v-if="fileShowFlag"
                      :refid="refid"
                      reftype="代理商注册-法人身份证"
                      :uploadflag="uploadflag||agentType==3&&isExpandAuthority?true:false"
                      :delflag="delflag"
                      :showtime="false">
                  </brupload>
                </el-form-item>
                <el-form-item label="一般纳税人提供相关资质证明" class="h-elformWrap-2" prop="upload" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                  <brupload
                      v-if="fileShowFlag"
                      :refid="refid"
                      reftype="代理商注册-一般纳税人提供相关资质证明"
                      :uploadflag="uploadflag||agentType==3&&isExpandAuthority?true:false"
                      :delflag="delflag"
                      :showtime="false">
                  </brupload>
                </el-form-item>
                <el-form-item label="名称修改见证性资料" class="h-elformWrap-2" prop="upload" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                  <brupload
                      :refid="refid"
                      reftype="代理商修改名称-见证性资料"
                      :uploadflag="uploadflag||agentType==3&&isExpandAuthority?true:false"
                      :delflag="delflag"
                      :showtime="false">
                  </brupload>
                </el-form-item>
                <el-form-item label="发票类型见证性资料" class="h-elformWrap-2" prop="upload" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                  <brupload
                      :refid="refid"
                      reftype="代理商修改发票-见证性资料"
                      :uploadflag="uploadflag||agentType==3&&isExpandAuthority?true:false"
                      :delflag="delflag"
                      :showtime="false">
                  </brupload>
                </el-form-item>
                <el-form-item label="备案表" class="h-elformWrap-2" prop="upload5" v-if="have2 && this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                  <brupload
                      v-model="formLabelAlign1.bscUserInfoAgentBasic.upload5"
                      v-if="fileShowFlag"
                      :refid="refid"
                      reftype="代理商注册-二类经营许可证"
                      :uploadflag="uploadflag||agentType==3&&isExpandAuthority?true:false"
                      :delflag="delflag"
                      @filecallback="fileBack1"
                      :showtime="false">
                  </brupload>
                </el-form-item>
                <el-form-item label="许可证有效截止日期" class="h-elformWrap-2" prop="xkzEffectiveDate" v-if="have3&&agentType!=3||have3&&agentType==3&&isExpandAuthority?true:false">
                  <el-date-picker
                      style="width: 180px"
                      v-model="formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate"
                      type="date"
                      placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="" class="HAVES-2 h-elformWrap-2" v-if="have2 && this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                  <el-switch
                      style="margin-left: 0.4rem;"
                      v-model="have6858"
                      active-text=""
                      inactive-text="是否包含6858">
                  </el-switch>
                  <el-switch
                      style="margin-left: 0.5rem;"
                      v-model="have6840"
                      active-text=""
                      inactive-text="是否包含6840">
                  </el-switch>
                </el-form-item>
                <el-form-item label="" class="HAVES-2 h-elformWrap-2" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                  <el-switch
                      style="margin-left:2.8rem;"
                      v-model="have3"
                      active-text=""
                      inactive-text="是否有许可证">
                  </el-switch>
                </el-form-item>
                <el-form-item label="许可证" class="h-elformWrap-1" prop="upload6" v-if="have3&&agentType!=3||have3&&agentType==3&&isExpandAuthority?true:false">
                  <div style="display: flex;align-items: center;">
                    <brupload
                        v-model="formLabelAlign1.bscUserInfoAgentBasic.upload6"
                        v-if="fileShowFlag||agentType==3&&isExpandAuthority"
                        :refid="refid"
                        reftype="代理商注册-三类经营许可证"
                        :uploadflag="uploadflag||agentType==3&&isExpandAuthority"
                        :delflag="delflag"
                        :showtime="false"
                        @filecallback="fileBack2"
                        style="width: 3rem;">
                    </brupload>
                    <el-switch
                        style="margin-left: 4rem;"
                        v-model="have6854"
                        active-text=""
                        inactive-text="是否包含6854">
                    </el-switch>
                  </div>
                </el-form-item>
                                <!--  补充  包含III类6840(体外诊断试剂 -->
                                <el-form-item label="是否包含III类6840(体外诊断试剂)" class="h-elformWrap-2" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false" >
                                    <el-switch
                                        v-model="haveThree6840"
                                        @change="chooseIVD"
                                        inactive-text="">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="三类经营许可证" class="h-elformWrap-2" v-if="this.haveThree6840 == true"
                                    :prop="this.haveThree6840 == true? 'upload8': '' ">
                                    <brupload
                                        v-model="formLabelAlign1.bscUserInfoAgentBasic.upload8"
                                        v-if="fileShowFlag"
                                        :refid="refid"
                                        reftype="三类6840经营许可证"
                                        :uploadflag="uploadflag||agentType==3&&isExpandAuthority?true:false"
                                        :delflag="delflag"
                                        @filecallback="fileBack3"
                                        :showtime="false">
                                    </brupload>

                                </el-form-item>
                            </el-form>
                            <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                                    ref="formLabelAlign1i"
                                    :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                                            ref="formLabelAlign1i"
                                            :inline="true" :rules="rules"
                                            class="demo-ruleForm h-formbLine h-formbLine1">
                                        <el-form-item label="许可证号" class="h-elformWrap-2" :prop="this.haveThree6840 == true? 'licenseNumber': '' "
                                            v-if="this.haveThree6840 == true">
                                            <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.licenseNumber"
                                                placeholder="请输入许可证号" >
                                            </el-input>
                                        </el-form-item>

                                    </el-form>
              </el-form>
            </div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="isShangWei">
              <h1>上传附件</h1>
            </div>
            <div class="h-formLine weekplandetail10" v-if="isShangWei">
              <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                       ref="formLabelAlign1i"
                       :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                <el-form-item label="名称修改见证性资料" class="h-elformWrap-2" prop="upload">
                  <brupload
                      :refid="refid"
                      reftype="代理商修改名称-见证性资料"
                      :uploadflag="uploadflag"
                      :delflag="delflag"
                      :showtime="false">
                  </brupload>
                </el-form-item>
                <el-form-item label="发票类型见证性资料" class="h-elformWrap-2" prop="upload">
                  <brupload
                      :refid="refid"
                      reftype="代理商修改发票-见证性资料"
                      :uploadflag="uploadflag"
                      :delflag="delflag"
                      :showtime="false">
                  </brupload>
                </el-form-item>

            </el-form>
            <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                ref="formLabelAlign1i" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1"
                v-if="!isShangWei || this.agentType == '3' || this.agentType == '1'">
                <el-form-item label="许可证号" class="h-elformWrap-2"  v-if="this.haveThree6840 == true"
                :prop="formLabelAlign1.bscUserInfoAgentSell.haveThree6840 == true? 'licenseNumber': '' " >
                    <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.licenseNumber"
                        placeholder="请输入许可证号" >
                    </el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div v-if="!isShangWei || this.agentType == '3'">
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="flag==='2'||flag==='3'||flag==='4' || this.agentType == '3'">
              <h1>资质审核</h1>
            </div>
            <div class="signsign" v-if="flag==='2'||flag==='3'||flag==='4' || this.agentType == '3'">
              <div class="h-formLine" style="margin-top:0.38rem">
                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                         ref="formLabelAlign14"
                         :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                  <el-form-item label="  经销商类别" class="h-elformWrap-2" prop="agentLevel" style="margin-left: 0.2rem;">
                    <div style="display: flex;margin-left: 0.2rem;">
                      <brselect category="DealerCategory_type" v-if="ct"  v-model="formLabelAlign1.bscUserInfoAgentBasic.agentLevel"
                                :v="formLabelAlign1.bscUserInfoAgentBasic.agentLevel"
                                 @change="changDealer($event)"
                                 style="width: 1.5rem!important;margin-left: 0.2rem;"
                                 placeholder="请选择">
                      </brselect>
                    </div>
                  </el-form-item>

                  <el-form-item label="对阵一级经销商" class="h-elformWrap-2" prop="oneLevelAgentName" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel==2">
                    <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName" :title="formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName" remote filterable :filter-method="showAgentList" clearable  placeholder="请输入"
                               :remote-method="showAgentList" @change="changeAgent($event)" >
                      <el-option v-for="(item) in oneAgentList"
                                 :key="item.customerName"
                                 :label="item.customerName"
                                 :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                         ref="formLabelAlign11"
                         :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="链群" class="h-elformWrap-2 w-elformWrap other" prop="goodsCategory"
                                  v-if="this.agentType!=3"  style="margin-left: -0.5rem;"
                    >
                      <item style="float: left">(</item>
                      <el-checkbox-group v-model="lianqunList" @change="lianqunOptions" style="float: left;margin-left: 10px;margin-right: 10px"
                      >
                        <el-checkbox label="X02">样本网</el-checkbox>
                        <el-checkbox label="X01" >药品网</el-checkbox>
                        <el-checkbox label="X08" >生物安全类</el-checkbox>
                        <el-checkbox label="X09" >培养箱类</el-checkbox>
                        <el-checkbox label="X10" >离心机</el-checkbox>
<!--                        <el-checkbox label="X07" >试剂网</el-checkbox>-->
                      </el-checkbox-group>
                      <item style="float: left">)</item>
                      <el-checkbox-group v-model="lianqunList" @change="lianqunOptions"  style="float: left;margin-left: 10px;margin-right: 10px"
                      >
                        <el-checkbox label="X05">血液网</el-checkbox>
                        <el-checkbox  label="X06">疫苗网</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  <el-form-item label="" class="h-elformWrap-1" prop="scale" style="margin-left: -0.5rem;">

                    <div style="display: flex;" v-if="this.isZhiDan != 1">
                      <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">
                        产品价格
                      </div>
                      <div style="display: flex;margin-left: 0.7rem;">
                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                          传统产品:
                        </div>
                        <el-select v-if="ct" v-model="ctLevel" @change="ctSelect"
                                   style="width: 1.5rem!important;margin-left: 0.2rem;"
                                   placeholder="请选择">
                          <el-option label="未签约" value=""></el-option>
                          <el-option label="一级产品价格" value="01"></el-option>
                          <el-option label="二级产品价格" value="02"></el-option>
                          <el-option label="三级产品价格" value="03"></el-option>
<!--                          <el-option label="直单价格" value="06"></el-option>-->
                          <el-option label="分销商价格" value="05"></el-option>
                        </el-select>
                      </div>
                      <div style="display: flex;margin-left: 0.7rem;">
                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                          U血液:
                        </div>
                        <el-select v-if="ND5" v-model="ND5Level"
                                   style="width: 1.5rem!important;margin-left: 0.2rem;"
                                   @change="ND5Select" placeholder="请选择">
                          <el-option label="未签约" value=""></el-option>
                          <el-option label="一级产品价格" value="01"></el-option>
                          <el-option label="二级产品价格" value="02"></el-option>
                          <el-option label="三级产品价格" value="03"></el-option>
                          <el-option label="分销商价格" value="05"></el-option>
                        </el-select>
                      </div>
                      <div style="display: flex;margin-left: 0.7rem;">
                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                          U疫苗:
                        </div>
                        <el-select v-if="ND4" v-model="ND4Level"
                                   style="width: 1.5rem!important;margin-left: 0.2rem;"
                                   @change="ND4Select" placeholder="请选择">
                          <el-option label="未签约" value=""></el-option>
                          <el-option label="一级产品价格" value="01"></el-option>
                          <el-option label="二级产品价格" value="02"></el-option>
                          <el-option label="三级产品价格" value="03"></el-option>
                          <el-option label="分销商价格" value="05"></el-option>
                        </el-select>
                      </div>
                      <div style="display: flex;margin-left: 0.7rem;">
                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                          航空温控:
                        </div>
                        <el-select v-if="NA9" v-model="NA9Level"
                                   style="width: 1.5rem!important;margin-left: 0.2rem;"
                                   @change="NA9Select" placeholder="请选择">
                          <el-option label="未签约" value=""></el-option>
                          <el-option label="一级产品价格" value="01"></el-option>
                          <el-option label="二级产品价格" value="02"></el-option>
                          <el-option label="三级产品价格" value="03"></el-option>
                          <el-option label="分销商价格" value="05"></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div style="display: flex;" v-if="this.isZhiDan == 1">
                      <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 1.1rem;">
                        产品价格
                      </div>
                      <div style="display: flex;margin-left: 0.7rem;">
                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                          传统产品:
                        </div>
                        <el-select v-if="ct" v-model="ctLevel" @change="ctSelect"
                                   style="width: 1.5rem!important;margin-left: 0.2rem;"
                                   placeholder="请选择">
                          <el-option label="未签约" value=""></el-option>
                          <el-option label="直单价格" value="04"></el-option>
                        </el-select>
                      </div>
                      <div style="display: flex;margin-left: 0.7rem;">
                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                          U血液:
                        </div>
                        <el-select v-if="ND5" v-model="ND5Level"
                                   style="width: 1.5rem!important;margin-left: 0.2rem;"
                                   @change="ND5Select" placeholder="请选择">
                          <el-option label="未签约" value=""></el-option>
                          <el-option label="直单价格" value="04"></el-option>
                        </el-select>
                      </div>
                      <div style="display: flex;margin-left: 0.7rem;">
                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                          U疫苗:
                        </div>
                        <el-select v-if="ND4" v-model="ND4Level"
                                   style="width: 1.5rem!important;margin-left: 0.2rem;"
                                   @change="ND4Select" placeholder="请选择">
                          <el-option label="未签约" value=""></el-option>
                          <el-option label="直单价格" value="04"></el-option>
                        </el-select>
                      </div>
                      <div style="display: flex;margin-left: 0.7rem;">
                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">
                          航空温控:
                        </div>
                        <el-select v-if="NA9" v-model="NA9Level"
                                   style="width: 1.5rem!important;margin-left: 0.2rem;"
                                   @change="NA9Select" placeholder="请选择">
                          <el-option label="未签约" value=""></el-option>
                          <el-option label="直单价格" value="04"></el-option>
                        </el-select>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="客户种类" class="h-elformWrap-2" prop="accountDistributeGroup">
                    <el-select
                        v-model="formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup"
                        :title="
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 10 ? '内销-海尔集团内（指国内市场所有海尔关联公司）':
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 20 ? '内销-海尔集团外（指国内市场所有非海尔关联公司）':
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 30 ? '外销-海尔集团内（指海外市场所有海尔关联公司）':
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 40 ? '外销-海尔集团外（指海外市场非海尔关联公司）':
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 50 ? '外销-合并范围内':
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 60 ? '内销-合并范围内':
                                                ''"
                        placeholder="请选择">
                      <el-option label="内销-海尔集团内（指国内市场所有海尔关联公司）-10" value="10"></el-option>
                      <el-option label="内销-海尔集团外（指国内市场所有非海尔关联公司）-20" value="20"></el-option>
                      <el-option label="外销-海尔集团内（指海外市场所有海尔关联公司）-30" value="30"></el-option>
                      <el-option label="外销-海尔集团外（指海外市场非海尔关联公司）-40" value="40"></el-option>
                      <el-option label="外销-合并范围内 -50" value="50"></el-option>
                      <el-option label="内销-合并范围内 -60" value="60"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="签约性质" class="h-elformWrap-2" prop="customerGroup2">
                    <el-select
                        v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup2"
                        placeholder="请选择">
                      <el-option label="签约经销商" value="01"></el-option>
                      <el-option label="非签约经销商" value="02"></el-option>
                      <!--                                            <el-option label="直单用户" value="03"></el-option>-->
                    </el-select>
                  </el-form-item>
                  <el-form-item label="分销渠道" class="h-elformWrap-2" prop="distributionChannel">
                    <brselectlazy category="YlSalesChannel_agent"
                                  :v="formLabelAlign1.bscUserInfoAgentSell.distributionChannel"
                                  v-model="formLabelAlign1.bscUserInfoAgentSell.distributionChannel"
                                  :clearable="true"
                                  style="width:2.27rem"/>
                  </el-form-item>
                  <el-form-item label="主销售渠道" class="h-elformWrap-2 w-elformWrap other" prop="customerGroup3">
                    <el-select :multiple="true"
                               :clearable="true"
                               v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup3"
                               :v="formLabelAlign1.bscUserInfoAgentSell.customerGroup3"
                               @change="getQudao"
                               :placeholder="flag==='2'?'':'请选择'">
                      <el-option v-for="item in qudaoNotMain"
                                 :key="item.index"
                                 :value="item.code"
                                 :label="item.name"
                                 :disabled="hasInclude(formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain,item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="非主销售渠道" class="h-elformWrap-2 w-elformWrap other" prop="customerGroup3NotMain">

                    <el-select :multiple="true"
                               :clearable="true"
                               v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain"
                               :v="formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain"
                               @change="getQudaoNotMain"
                               :placeholder="flag==='2'?'':'请选择'">
                      <el-option v-for="item in qudaoNotMain"
                                 :key="item.index"
                                 :value="item.code"
                                 :label="item.name"
                                 :disabled="hasInclude(formLabelAlign1.bscUserInfoAgentSell.customerGroup3,item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="销售区域" class="h-elformWrap-2 w-elformWrap" prop="salesRegion">
                    <brselectlazy :multiple="true" category="YlSalesArea_chanpin"
                                  v-if="this.agentType != '3'"
                                  :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                  v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                  :clearable="true"/>
                    <div v-if="this.agentType == '3'">
                                                        <SPAN v-if="this.isExpandAuthority != '1'">

                                                            <brselectlazy :multiple="true" category="YlSalesArea"
                                                                          :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                                          v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                                          :clearable="true"/>
                                                        </SPAN>
                      <span v-else>

                                                            <brselectlazy :multiple="true" category="YlSalesArea_chanpin"
                                                                          :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                                          v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                                          :clearable="true"/>
                                                        </span>

                    </div>

                  </el-form-item>
                </el-form>
                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                         ref="formLabelAlign12"
                         :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                  <el-form-item label="签约公司" class="h-elformWrap-2 w-elformWrap" prop="companyCode">
                    <brselectlazy :multiple="true" category="YlCompanyCode_agent"
                                  :v="formLabelAlign1.bscUserInfoAgentBasic.companyCode"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.companyCode"
                                  :clearable="true"
                                  style="width:100%"/>
                  </el-form-item>
                  <!-- 公司代码9390时，系统自动默认5个链群：-->
                  <!--                                    <el-form-item label="链群" class="h-elformWrap-2 w-elformWrap" prop="goodsCategory" v-if="this.agentType!=3&&isShowAllSelect">
                                                          <brselectlazy :multiple="true" category="YlGoods_category"
                                                                        :v="formLabelAlign1.bscUserInfoAgentBasic.goodsCategory"
                                                                        v-model="formLabelAlign1.bscUserInfoAgentBasic.goodsCategory"
                                                                        :isCheckbox="isShowAllSelect"
                                                                        :clearable="true"
                                                                        :disabled="$store.getters.hasRole('swyl_quyujl')?true:false"
                                                                        style="width:100%"
                                                                        />
                                                      </el-form-item>
                                                      &lt;!&ndash;isBlood  是否血站专用渠道（杨宝栋[01023980]）  1 是  0 不是&ndash;&gt;
                                                      <span  class="h-elformWrap-6"  v-if="this.agentType!=3" style="margin-left: 62px">
                                                          <el-switch style="margin-left: 20px;width: 100%"
                                                                     v-model="isBlood"
                                                                     :disabled="$store.getters.hasRole('swyl_wanglgly')?false:true"
                                                                     active-text="是否血站专用渠道">
                                                          </el-switch>
                                                      </span>-->
                </el-form>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div style="text-align: center;margin-top: 0.5rem">
        <el-button class="h-btn h-bBtn h-bgwhite"
                   @click="goBack">返回
        </el-button>
        <el-button class="h-btn h-bBtn h-bggreen" @click="saveGYDls('formLabelAlign1')"
                   v-if="this.flag==='2' && this.agentType == '3'">暂存
        </el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2"
                   @click="insert('formLabelAlign1')">提交
        </el-button>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    <areaSelect :visible.sync="showflag2" @choseObj="choseObj2" v-if="showflag2"
                v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"/>
    <areaSelect :visible.sync="showflag" @choseObj="choseObj" v-if="showflag"
                v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"/>
  </div>
</template>
<script>
import ss from '../../../api/SystemService';
import agentCopyService from "../../../api/loud/agent/agentCopyService";

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.check.checkpassword !== '') {
          this.$refs.formLabelAlign1a.validateField('checkpassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formLabelAlign1.bscUserInfo.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validateCompany = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司名称'));
      } else if (value !== '') {
        ss.SignService.checkCompany(value).then(response => {
          console.log(response, '验证公司信息')
          if (response.obj.status === '200') {
            this.companyData = response.obj.data;
            callback();
            this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.companyData.address;
            // this.formLabelAlign1.bscUserInfoAgentBasic.http = this.companyData.websites[0].web_url;
            this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.companyData.econ_kind;
            this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.companyData.start_date;
            this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.companyData.regist_capi;
            this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.companyData.oper_name;
            this.formLabelAlign1.bscUserInfoAgentBasic.business = this.companyData.scope;
            this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.companyData.credit_no;
            this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.companyData.address;
            this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.companyData.contact.telephone;
          } else {
            callback(new Error('请输入正确的公司名称!'));
          }
        })

      }
    };
    return {
      isShowAllSelect:false,//判断是否展示全部群连并checkout
                haveThree6840:0,
      userName1: false,
      taxCode: false,
      phoneNumber: false,
      cityStreetRoom: false,
      bankBranchCode: false,
      bankName: false,
      accountHolderName: false,
      bankCountry: false,
      customerGroup1: false,
      changedParamList: [],
      isZhiDan: false,
      isExpandAuthority:false,
      isBlood:false,
      isGoverment: false,
      mailreceiver:false,
      receiverphone:false,
      mailaddress:false,
      // isShowSkipLeader: false,
      isShangWei: false,
      ctLevel: '',
      ND4Level: '',
      ND5Level: '',
      ND6Level: '',
      NA9Level: '',
      dealerType:'',
      ct: true,
      ND4: true,
      ND5: true,
      ND6: true,
      NA9: true,
      haiwairen: false,
      guanliren: false,
      checkedlevels: [],
      levels: ['传统产品', 'U血液', 'U试剂', 'U疫苗'],
      checkAll: false,
      isIndeterminate: true,
      have6858: false,
      have6840: false,
      have6854: false,
      showhistory: false,
      instid: null,
      companyData: null,
      showflag: false,
      showflag2: false,
      have2: true,
      have3: false,
      options: [],
      value: [],
      listSelect: [],
      addli: [],
      oneAgentList:[],
      lianqunList:[],
      qudaoNotMain:[],
      associatedCompanyList:[],
      qudao:[],
      loadingSelect: false,
      states: [],
      isShowMassage: true,
      isShowByHw:true,
      radio: '国内客户',
      fileShowFlag: false,
      uploadflag: true,
      delflag: true,
      refid: this.$util.getUuid(),
      loading: false,
      isTwoAgent:false,
      ind: null,
      index: ['c', 'd','h', 'i', 'f', 'e'],
      index1: ['c', 'd','h', 'i', 'f', 'e', '1','2','4'],
      list: ["我是经销商", "我是供应商"],
      indx: 0,
      agentLevel:'',
      oneLevelAgent:'',
      formLabelAlign1: {
        bscUserInfoAgentBasic: {
          usercode: null,
          customerNumber: null,
          accountGroup: null,// 科目组 , 配置项 , 调接口参数: YlCustomerAccountGroup , 字段输入限制:  0210 集团内客户 0260 海外客户 0280 国内客户 根据客户实际情况传入科目组代码  , 特殊限制:   付款条件销售平台更改
          customerName1: '',// 客户全称1 ,  ,   , 字段输入限制: 客户全名。国内客户要求与证件注册的名称相同 , 特殊限制:   更改账期接口（公司销售视图付款条件字段）
          customerTitle: null,// 客户标题 ,  ,   , 字段输入限制:  公司 先生 女士 先生和夫人 一般公司类客户数据，可以默认传入“公司”  ,
          searchTerm: null,// 搜索项 ,  ,   ,   ,
          postalCode: null,// 邮政编码 ,  ,   ,   ,
          country: null,// 国家代码 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 传入国家的代码，在list中选择 ,
          region: null,// 地区 , 配置项 , 调接口参数: YlRegion , 字段输入限制: 传入地区的代码，在国家代码下的list中选择 ,
          cityStreetRoom: '',// 城市 ,  ,   , 字段输入限制: 客户所在的城市中文名 ,
          streetRoom: null,// 街道 ,  ,   , 字段输入限制: 客户证件上的注册地址 ,
          phoneNumber: null,// 电话 ,  ,   , 字段输入限制: 客户证件上注册的电话，开发票使用 , 特殊限制: 最多16位
          language: null,// 语言代码 , 配置项 , 调接口参数: YlLanguageType , 字段输入限制: 默认传入“ZH” ,
          faxNumber: null,// 传真 ,  ,   ,   , 特殊限制: 最多16位
          contactMobilePhone: null,// 移动电话 ,  ,   ,   , 特殊限制: 最多16位
          companyCodeGeneral: null,// 公司代码(记录0210账户组下客户公司对照关系) , 配置项 , 调接口参数: CompanyCode , 字段输入限制: 当建立集团内客户时，此字段不能为空，需传入集团4位公司代码 ,
          companyCode: null,// 公司代码 , 是否必填: 是 , 是否配置项: 是 , 值集代码: YlCompanyCode , 注释:
          goodsCategory: null,// 商品大类 , 是否必填：否 , 是否配置项：是 , 值集代码：YlGoodsCategory
          taxCode: null,// 纳税人登记号 ,  ,   , 字段输入限制: 客户证件注册的统一信用代码，开发票使用 ,
          name1: null,// 联系人名称 ,  ,   , 字段输入限制: 客户方联系人的名字 ,
          phoneNumber1: null,// 联系人电话1 ,  ,   , 字段输入限制: 客户方联系人的电话 , 特殊限制: 最多16位
          companyAddress: null,// 公司地址名 ,  ,   ,   ,
          contactCity: null,// 联系人城市 ,  ,   ,   ,
          appellation: null,// 称谓 ,  ,   , 字段输入限制:  女士 先生  ,
          partnerFlagSp: null,// 是否有售达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagSh: null,// 是否有送达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagBp: null,// 是否有开票方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagPy: null,// 是否有付款方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          scale: null,//纳税人规模  0：小规模经营者   1：一般纳税人
          http: null,//公司网址
          companytype: null, //公司性质
          founded: null,//成立时间
          regmoney: null,//注册资本
          legal: null,//法人姓名
          introduce: null,//公司简介
          business: null,//主营
          achievement: null,//业绩
          resource: null,//资源
          email: null,//公司邮箱
          remark: null,//备注
          upload5: null,
          upload6: null,
                        upload8: null,
          isTrade: null,
          agentLevel:null,
          oneLevelAgent:null,
          oneLevelAgentName:null,
          associatedCompanyName:null,//关联公司
          associatedCompanyCode:null,
        },
        bscUserInfoAgentBank: {
          usercode: null,//公司编码
          accountHolderName: null,// 银行帐户 ,  ,   , 字段输入限制: 开户许可证上的银行账号 ,
          bankCountry: null,// 银行所属国家 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 从国家列表中选择 ,
          bankBranchCode: null,// 银行码 , 配置项 , 调接口参数: 从MDM开放的银行接口中选择 , 字段输入限制: 从MDM开放的银行接口中选择 ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          vatCode: null,//VAT税号
          bankName: null//银行名称
        },
        bscUserInfoAgentSell: {
          usercode: null,//公司编码
          distributionChannel: null,// 分销渠道 , 配置项 , 调接口参数: YlSalesChannel ,   ,
          division: null,// 产品组 , 配置项 , 调接口参数: YLProductGroup , 字段输入限制: 默认00 ,
          salesGroup: null,// 销售组织 , 配置项 , 调接口参数: YLSalesOrganization ,   ,
          salesRegion: '',// 销售地区 , 配置项 , 调接口参数: YlSalesArea ,   ,
          customerGroup: null,// 客户组(经销商级别) , 配置项 , 调接口参数: YlCustomerGroup , 字段输入限制: 内销必填 ,
          currencyCode: null,// 货币代码 , 配置项 , 调接口参数: YlCurrency ,   ,
          customerPricingProccess: null,// 客户定价过程 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          customerSummaryGroup: null,// 客户统计组 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          shipCondition: null,// 装运条件 , 配置项 , 调接口参数: 默认传01 , 字段输入限制: 默认传01 ,
          shipPlant: null,// 交货工厂 , 配置项 , 调接口参数: YlPLPlantCode ,   ,
          accountDistributeGroup: null,// 客户组的帐户分配 , 配置项 , 调接口参数: YlAccountDistributeGroup ,   ,
          custTaxCategory: null,// 客户的税分类 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          paymentTerms1: null,// 付款条件-未包含在最近模板 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认传0000 ,
          podRelation: null,// 与 POD 处理相关 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          orderPossibility: null,// 订单可能性 ,  ,   ,   ,
          intCommercialTerms: null,// 国际贸易条件 , 配置项 , 调接口参数: YlCommercialTerms , 字段输入限制: 外销必填 ,
          intCommercialTerms2: null,// 国际贸易条件(部分2) ,  ,   , 字段输入限制: 外销必填 ,
          fullDelivery: null,// 全部交货 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          partDelivery: null,// 每个项目允许的部分交货最大数 ,  ,   , 字段输入限制: 默认传9 ,
          orderComposeIdentif: null,// 订单组合标识 ,  ,   , 字段输入限制: 传X或空  默认传X ,
          customerGroup1: null,// 客户组 1(开票类型) , 配置项 , 调接口参数: YlCustomerGroup1 , 字段输入限制: 内销必填 ,
          customerGroup2: null,// 客户组 2(经销商类型) , 配置项 , 调接口参数: YlCustomerGroup2 , 字段输入限制: 内销必填 ,
          customerGroup3: null,// 客户组 3(渠道类型) , 配置项 , 调接口参数: YlCustomerGroup3 , 字段输入限制: 内销必填 ,
          customerGroup3NotMain:null,//客户组 3(渠道类型 非主渠道)
          rebate: null,// 回扣 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          closeRoundingOff: null,// 关闭舍入 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          permit: null,//资质标识 1二级 2三级
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          customerAssignGroup: '0210', //客户分配账户组: 10内销-集团内 20内销-集团外
          auditMind1: null, //审核意见
          auditMind2: null, //审核意见
                haveThree6840:'',//
                licenseNumber:'',
          agentLevel:null,//经销商级别
          dealerType:null,//经销商类别
        },
        bscUserInfoAgentCompany: {
          usercode: null,//公司编码
          companyCode: null,// 公司代码 , 配置项 , 调接口参数: YlCompanyCode ,   ,
          hq: null,// 总部 ,  ,   ,   ,
          reconcileAccount: null,// 统驭科目 , 配置项 , 调接口参数: YLReconcileAccount , 字段输入限制:  0230、0260、0280账户组默认1122002000 0210默认1122001000  ,
          sequenceNo: null,// 排序码 , 配置项 , 调接口参数: YlOrderCode , 字段输入限制: 默认001 ,
          paymentTerm: null,// 付款条款 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认0000 ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          mailreceiver: null,//邮寄接收人
          receiverphone: null,//接收人电话
          mailaddress: null,//邮寄地址
        },
        bscUserInfo: {
          usercode: null,//员工编码/公司编码
          password: '',//密码
          usertype: null,//用户类别: 0-内部员工  1-经销商  2-供应商
          username: '',//公司名称/员工姓名username
          email: null,//邮箱
          phone: null,//联系人电话
          deptcode: null,//所属部门编码deptcode  公司用户为空
          userdept: null,//用户详细部门userdept  公司用户为空
          deptname: null,//部门名称deptname  公司用户为空
          firstline: null,//一线经理firstline  公司用户为空
          secondline: null,//二线经理secondline  公司用户为空
          status: null,//用户状态: 0--禁用/冻结  1--正常  2--用户被删除
          organization: null,//公司地址/住址机构
          cdate: null,//创建时间
          ldate: null,//更新时间
          logintimes: null,//登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
          lastlogintime: null,//最后登录时间: 记录最后登录时间
          accountdate: null,//账户有效期
          area: null,//负责区域
          lucode: null,//更新人编码
          countrytype: null,//1- 国内  /  2- 国外   账户
          fileId: null,
          aaa: null,
          taskid: null,
        },
        levelMap: {},
        saveAndSubmit: '1'
      },
      data: {},
      check: {
        checkpassword: ''
      },
      rules: {
        //纳税人登记号
        taxCode: [
          {required: this.isShowByHw, message: '请填写必填项', trigger: 'blur'},
        ],
        //银行编号
        bankBranchCode: [
          {required: this.isShowByHw, message: '请填写必填项', trigger: 'blur'},
        ],
        //银行名称
        bankName: [
          {required: this.isShowByHw, message: '请填写必填项', trigger: 'blur'},
        ],
        //银行账户号
        accountHolderName: [
          {required: this.isShowByHw, message: '请填写必填项', trigger: 'blur'},
        ],
        //银行所属国家
        bankCountry: [
          {required: this.isShowByHw, message: '请填写必填项', trigger: 'blur'},
        ],
        username: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        isZhidan: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        customerGroup1: [
          {required: this.isShowByHw, message: '请填写必填项', trigger: 'blur'},
        ],
        companyAddress: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        email:[
                    {required: true, message: '请填写必填项', trigger: 'blur'}
                ],
        contactCity: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        currencyCode: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        accountDistributeGroup: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        customerGroup2: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        customerGroup3: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        salesRegion: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        distributionChannel: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        companyCode: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        contactMobilePhone: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        password:
            [
              {required: true, validator: validatePass, trigger: 'blur'},
            ],
        checkpassword:
            [
              {required: true, validator: validatePass2, trigger: 'blur'},
            ],
        customerName1:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        country:
            [
              {required: true, message: '请填写必填项', trigger: 'change'},
            ],
        region:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        cityStreetRoom:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        streetRoom:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        isTrade:
            [
              {required: true, message: '请填写必填项', trigger: 'change'},
            ],
        phoneNumber:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        name1:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        phoneNumber1:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        companyCodeGeneral:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        reconcileAccount:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        salesGroup:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        intCommercialTerms:
            [
              {required: true, message: '请填写必填项', trigger: 'change'},
            ],
        intCommercialTerms2:
            [
              {required: true, message: '请填写必填项', trigger: 'change'},
            ],
        upload5:
            [
              {required: true, message: '请上传资料', trigger: 'blur'},
            ],
        upload6:
            [
              {required: true, message: '请上传资料', trigger: 'blur'},
            ],
                    upload8:
                        [
                            {required: true, message: '请上传资料', trigger: 'blur'},
                        ],
                    licenseNumber:[
                        {required: true, message: '请输入许可证号', trigger: 'blur'},
                    ],
        agentLevel: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        oneLevelAgentName: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
      },
      rules1: {
        distributionChannel: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        accountDistributeGroup: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        customerGroup1: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        customerGroup2: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        customerGroup3: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        salesRegion: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        auditMind1: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        companyCode: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
      },
      flag: '',
      modelList: [],
      agentType: 1,
      rules1Index: ['1', '2'],
      rules1Index1: ['3'],
    }
  },
  created() {
    console.log(this.$route.query, 'query')
    this.findAddress();
    ss.Dictservice.listbycategory("sales_region").then(response => {
      console.log(response, "sales_chanle")
      this.qudaoNotMain = response;
      this.qudao = response;
    })
    this.guanliren = this.$store.getters.hasRole("swyl_admin");
    this.haiwairen = this.$store.getters.hasRole("swyl_waixiaogly,swyl_xiaoshoujl_wx,xiaoshoujingli-waixiao,swyl_haiwailq_xiaoweizhu,hwxsybgly");
    //创建经销商进入
    if (this.$route.query.index == '1') {
      this.refid = this.$util.getUuid();
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;
      this.fileShowFlag = true;
      this.formLabelAlign1.bscUserInfoAgentBasic.scale = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
      this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
      this.formLabelAlign1.bscUserInfoAgentCompany.sequenceNo = '001';
      this.formLabelAlign1.bscUserInfoAgentCompany.paymentTerm = '0000';
      this.formLabelAlign1.bscUserInfoAgentSell.division = '00';
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
      this.formLabelAlign1.bscUserInfoAgentSell.customerPricingProccess = '1';
      this.formLabelAlign1.bscUserInfoAgentSell.customerSummaryGroup = '1';
      this.formLabelAlign1.bscUserInfoAgentSell.shipCondition = '01';
      this.formLabelAlign1.bscUserInfoAgentSell.custTaxCategory = '1';
      this.formLabelAlign1.bscUserInfoAgentSell.paymentTerms1 = '0000';
      this.formLabelAlign1.OperateType = 'CREATE';
      this.formLabelAlign1.OPERATOR = this._user.username;
      this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = 'CN';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSp = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagBp = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagPy = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSh = '1';

      this.agentType = 2;
      this.isShowMassage = true;
      //创建经销商默认是国内经销商  客户分配账户组默认是20(内销集团外)
      this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '20';
      this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
      this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
      this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
      this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
      this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
      ss.Dictservice.listbycategory("sales_region").then(response => {
        console.log(response, "sales_chanle")
        this.options = response;
      })
      if (this.haiwairen) {
        this.radio = '海外客户';
        this.changeType("海外客户");
      }
    } else if (this.$route.query.index === '2' || this.$route.query.index === '3') {
      this.refid = this.$route.query.fileidInfo;
      this.fileShowFlag = true;
      if (this.$route.query.agentTypeBas == '3') {
        this.radio = '海外客户';
        this.agentType = 3;
        this.have3 = false;
        this.changeType('海外客户');
      } else if (this.$route.query.agentTypeBas == '1') {
        this.radio = '国内客户';
        this.agentType = 2;
        this.changeType('国内客户');
      } else if (this.$route.query.agentTypeBas == '2') {
        this.radio = '上海直销';
        this.agentType = 1;
        this.changeType('上海直销');
      }
      if (this.$route.query.permitSell == 5) {
        this.have2 = true;
        this.have3 = true;
      } else if (this.$route.query.permitSell == 2) {
        this.have2 = true;
      } else if (this.$route.query.permitSell == 3) {
        this.have3 = true;
      }
      console.log("查看");
      this.queryLevel(this.$route.query.customergroupSell);
    } else if (this.$route.query.taskid != null) {
      console.log("审批进入页面")
      console.log(this.$store.getters.roles, 'store')
      for (var i = 0; i < this.$store.getters.roles.length; i++) {
        if (this.$store.getters.roles[i].id == 'swyl_dingdgly') {
          this.isShangWei = true;
          agentCopyService.checkWhatChange(this.$route.query.ywid).then(res => {
            this.changedParamList = res;
            if (this.changedParamList.includes("customerName1")) {
              this.userName1 = true;
            }
            if (this.changedParamList.includes("taxCode")) {
              this.taxCode = true;
            }
            if (this.changedParamList.includes("phoneNumber")) {
              this.phoneNumber = true;
            }
            if (this.changedParamList.includes("cityStreetRoom")) {
              this.cityStreetRoom = true;
            }
            if (this.changedParamList.includes("bankBranchCode")) {
              this.bankBranchCode = true;
            }
            if (this.changedParamList.includes("bankName")) {
              this.bankName = true;
            }
            if (this.changedParamList.includes("accountHolderName")) {
              this.accountHolderName = true;
            }
            if (this.changedParamList.includes("bankCountry")) {
              this.bankCountry = true;
            }
            if (this.changedParamList.includes("customerGroup1")) {
              this.customerGroup1 = true;
            }
            if (this.changedParamList.includes("mailreceiver")) {
              this.mailreceiver = true;
            }
            if (this.changedParamList.includes("receiverphone")) {
              this.receiverphone = true;
            }
            if (this.changedParamList.includes("mailaddress")) {
              this.mailaddress = true;
            }
          })
        }
      }
      var id = this.$route.query.ywid;
      this.instid = this.$route.query.instid;
      this.formLabelAlign1.bscUserInfo.taskid = this.$route.query.taskid;
      // agentCopyService.getNowTask(this.$route.query.taskid).then(res => {
      //     this.isShowSkipLeader = res;
      // });
      console.log(id,"////////////");
      agentCopyService.queryOnesh(id).then(response => {
        console.log(response, 'response1111')
        this.data = response.obj;
        this.uploadflag = false;
        this.delflag = false;
        this.rules = {};
        this.flag = '4';
        this.refid = this.data.fileidInfo;
        this.fileShowFlag = true;
        console.log(this.data,"结果如何");
        this.checkDetail();
        console.log(this.refid, 'refid')
        console.log(response.obj.agentTypeBas,"group");

        if (response.obj.agentTypeBas == '1') {
          this.radio = '国内客户';
          this.agentType = 2;
          this.isShowMassage = true;
          //若国内客户没有客户分配账户组  则默认是20(内销集团外)
          if (!response.obj.accountdistributegroupSell || response.obj.accountdistributegroupSell == '') {
            this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '20';
          }
        } else if (response.obj.agentTypeBas == '2') {
          this.radio = '上海直销';
          this.agentType = 1;
          this.isShowMassage = true;
        } else if (response.obj.customerassigngroupSell == '0260' || response.obj.agentTypeBas == '3') {
          this.radio = '海外客户';
          this.agentType = 3;
          this.isShowMassage = false;
          //若海外客户没有客户分配账户组  则默认是40(外销集团外)
          if (!response.obj.accountdistributegroupSell || response.obj.accountdistributegroupSell == '') {
            this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '40';
          }
        }
        if (response.obj.permitSell === 5) {
          this.have2 = true;
          this.have3 = true;
        } else if (response.obj.permitSell === 2) {
          this.have2 = true;
        } else if (response.obj.permitSell === 3) {
          this.have3 = true;
        }
        this.queryLevel(response.obj.customergroupSell);
        // if (response.obj.iszhidanBas == 1){
        //     this.ctLevel = '04';
        //         this.ND4Level = '04';
        //         this.ND5Level = '04';
        //         this.ND6Level = '04';
        // }
      });

    }
  },
  beforeRouteLeave(to,from,next){
    if(to.path=='/agent/agentCopy' && from.path == '/agentDetail'){
      to.meta.keepAlive = true;
    }else{
      to.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    findAddress() {
      ss.SignService.selectAddress().then(response => {
        this.addli = response;
      })
    },
    chooseZhiDan() {
      if (this.isZhiDan) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 1;
        if (this.agentType == '3') {
          this.formLabelAlign1.levelMap['ct'] = '04';
          this.formLabelAlign1.levelMap['ND4'] = '04';
          this.formLabelAlign1.levelMap['ND5'] = '04';
          this.formLabelAlign1.levelMap['ND6'] = '04';
          this.formLabelAlign1.levelMap['NA9'] = '04';
        }
      } else {
        this.isGoverment = false;
        this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "";
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 0;
        if (this.agentType == '3') {
          this.formLabelAlign1.levelMap['ct'] = '01';
          this.formLabelAlign1.levelMap['ND4'] = '01';
          this.formLabelAlign1.levelMap['ND5'] = '01';
          this.formLabelAlign1.levelMap['ND6'] = '01';
          this.formLabelAlign1.levelMap['NA9'] = '01';
        }
      }
    },
    chooseGoverment() {
      if (this.isGoverment) {
        this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "政府/军工企业";
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "";
      }

    },
    //是否开通海外直单权限
    chooseAddAbroad(){
      if (this.isExpandAuthority) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = 1;
        console.log("开通权限")
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = 0;
        console.log("暂不开通")
      }
    },
    //是否开通国内下单权限  仅针对海外客户
    chooseDomestic(){
      if (this.isExpandAuthority ) {
        this.isShowByHw = true;
        // this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthorityBas = 1;
        console.log("水水水水")
      } else {
        this.isShowByHw = false;
        // this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthorityBas = 0;
        console.log("呃呃呃呃")
      }
    },
    //是否开通血站 国内和上海特有
    chooseIsBlood(){
      if (this.isBlood) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = 1;
        console.log("开通血站")
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = 0;
        console.log("暂不开通血站")
      }
    },
            //是否开通体外试剂
    chooseIVD(){
            if (this.haveThree6840) {
                this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = 1;
                console.log("包含")
            } else {
                this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = 0;
                console.log("不包含III类6840")
            }
        },
    // changeCountry(attr){
    //     if (attr == "CN" || attr == "中国") {
    //        this.shifouTrade = true;
    //     }else{
    //        this.shifouTrade = false;
    //     }
    // },
    changeTrade(attr) {
      if (attr == "1" || attr == "是") {
        this.isShowByHw = true;
      }else{
        this.isShowByHw = false;
      }
    },
    queryLevel(v) {
      agentCopyService.queryLevel(v).then(response => {
        console.log(response, 'levelmap')
        if (response.ct != undefined) {
          this.checkedlevels.push("传统产品");
          this.ctLevel = response.ct;
          this.ct = true;
          this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
        }
        if (response.ND4 != undefined) {
          this.checkedlevels.push("U疫苗");
          this.ND4Level = response.ND4;
          this.ND4 = true;
          this.formLabelAlign1.levelMap['ND4'] = this.ND4Level;
        }
        if (response.ND5 != undefined) {
          this.checkedlevels.push("U血液");
          this.ND5Level = response.ND5;
          this.ND5 = true;
          this.formLabelAlign1.levelMap['ND5'] = this.ND5Level;
        }
        if (response.ND9 != undefined) {
          this.checkedlevels.push("U试剂");
          this.ND6Level = response.ND9;
          this.ND6 = true;
          this.formLabelAlign1.levelMap['ND6'] = this.ND6Level;
        }
        if (response.NA9 != undefined) {
          this.checkedlevels.push("U血液");
          this.NA9Level = response.NA9;
          this.NA9 = true;
          this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
        }
      })
    },
    ctSelect() {
      this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
    },
    ND4Select() {
      this.formLabelAlign1.levelMap['ND4'] = this.ND4Level;
    },
    ND5Select() {
      this.formLabelAlign1.levelMap['ND5'] = this.ND5Level;
    },
    ND6Select() {
      this.formLabelAlign1.levelMap['ND6'] = this.ND6Level;
    },
    NA9Select() {
      this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
    },
    handleCheckAllChange(val) {
      console.log(val, '全选')
      if (val) {
        this.ct = true;
        this.ND4 = true;
        this.ND5 = true;
        this.ND6 = true;
        this.NA9 = true;
      } else {
        this.ct = false;
        this.ND4 = false;
        this.ND5 = false;
        this.ND6 = false;
        this.NA9 = false;
      }
      this.checkedlevels = val ? this.levels : [];
      this.isIndeterminate = false;

    },
    handleCheckedCitiesChange(value) {
      console.log(value, '级别分类')
      this.ct = false;
      this.ND4 = false;
      this.ND5 = false;
      this.ND6 = false;
      this.NA9 = false;
      this.formLabelAlign1.levelMap = {};
      for (var i = 0; i < value.length; i++) {
        if (value[i] == '传统产品') {
          this.ct = true;
          this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
        } else if (value[i] == 'U血液') {
          this.ND5 = true;
          this.formLabelAlign1.levelMap['ND5'] = this.ND5Level;
        } else if (value[i] == 'U试剂') {
          this.ND6 = true;
          this.formLabelAlign1.levelMap['ND6'] = this.ND6Level;
        } else if (value[i] == 'U疫苗') {
          this.ND4 = true;
          this.formLabelAlign1.levelMap['ND4'] = this.ND4Level;
        } else if (value[i] == '航空温控') {
          this.NA9 = true;
          this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
        }
      }
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.levels.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.levels.length;
    },
    choseObj2(obj) {
      console.log(obj)
      this.showflag2 = false;
      if (obj.zhenobj && obj.zhenobj.name) {
        this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
      }
    },
    viewpress() {
      this.showhistory = true;
    },
    fileBack1(v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload5 = v.length;
    },
    fileBack2(v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload6 = v.length;
    },
            fileBack3(v) {
                console.log(v)
                this.formLabelAlign1.bscUserInfoAgentBasic.upload8 = v.length;
            },

    handleIconClick() {
      this.showflag = true;
    },
    handleIconClick2() {
      this.showflag2 = true;
    },
    choseObj(obj) {
      console.log(obj)
      this.showflag = false;
      if (obj.zhenobj && obj.zhenobj.name) {
        this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
      } else {
        this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
      }
    },
    changeType(v) {
      if (v === '海外客户') {
        this.agentType = 3;
        this.isShowMassage = false;
        this.isShowByHw = false;
        this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '40';
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentBasic.country = '';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = '';
        this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = '';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '3';
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
      } else if (v === '上海直销') {
        this.agentType = 1;
        this.isShowMassage = true;
        this.isShowByHw = true;
        this.uploadflag = true;
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0210';
        // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0210';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '2';
      } else if (v === '国内客户') {
        this.agentType = 2;
        this.isShowMassage = true;
        this.isShowByHw = true;
        this.uploadflag = true;
        if (!this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup || this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == '') {
          this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '20';
        }
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
      }
    },
    //通过审批按钮功能
    update(formName) {
      if (!this.isShangWei) {
        var flag = 0;
        for (var i = 0; i < this.rules1Index.length; i++) {
          this.ind = this.rules1Index[i];
          var form =formName + this.ind;
          this.$refs[form].validate((valid) => {
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
        // console.log(flag)
        if (flag !== 0) {
          return false;
        }
        // if (this.data.iszhidanBas == 1) {
        //     this.formLabelAlign1.levelMap['ct'] = '04';
        //     this.formLabelAlign1.levelMap['ND4'] = '04';
        //     this.formLabelAlign1.levelMap['ND5'] = '04';
        //     this.formLabelAlign1.levelMap['ND6'] = '04';
        // }
      }
      this.formLabelAlign1.bscUserInfo.aaa = 1;
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;
      console.log(this.formLabelAlign1);
      console.log("^^^^^^^^^^^^^^^^^^^^^^^^^");
      agentCopyService.agentPass(this.formLabelAlign1).then(response => {
        if (response.f) {
          this.$msg.alerts("提交成功！", () => {
            //刷新右上角的代办个数
            this.$store.dispatch("searchTasktotal")
            //跳转回系统的代办列表
            this.$router.push({path: '/personal/dealCenter'})
          })
        }
      })
    },
    //驳回按钮功能
    reject(formName) {
      var flag = 0;
      for (var i = 0; i < this.rules1Index1.length; i++) {
        this.ind = this.rules1Index1[i];
        var form = formName + this.ind;
        // console.log(form)
        this.$refs[form].validate((valid) => {
          if (valid) {

          } else {
            flag = flag + 1;
            return false;
          }
        });
      }
      if (flag !== 0) {
        return false;
      }
      this.formLabelAlign1.bscUserInfo.aaa = 2;
      agentCopyService.agentPass(this.formLabelAlign1);
      var defaultpage = this._user.defaultpage;
      this.$router.push({path: defaultpage});
      // this.formLabelAlign1.bscUserInfo.status = '5';
    },
    //经销商查看功能对应展示数据功能
    checkDetail() {
      console.log("---------------");
      console.log(this.data);
      this.formLabelAlign1.bscUserInfo.usercode = this.data.usercodeInfo
      if(this.data.usercodeBas) {
        this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeBas
      }else {
        this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeInfo
      }

      this.formLabelAlign1.bscUserInfoAgentBank.usercode = this.data.usercodeBank
      this.formLabelAlign1.bscUserInfoAgentCompany.usercode = this.data.usercodeCom
      this.formLabelAlign1.bscUserInfoAgentSell.usercode = this.data.usercodeSell

      this.formLabelAlign1.bscUserInfo.username = this.data.usernameInfo


      this.formLabelAlign1.bscUserInfo.password = this.data.passwordInfo
      if(this.data.customername1Bas) {
        this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
      }else {
        this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.usernameInfo
      }

      if (this.data.scaleBas !== undefined) {
        this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scaleBas
      }
      if (this.data.companyaddressBas && this.data.companyaddressBas != '') {
        this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.companyaddressBas
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.streetroomBas
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.isTrade = this.data.isTradeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = this.data.faxnumberBas
      this.formLabelAlign1.bscUserInfoAgentBasic.http = this.data.httpBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.data.companytypeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.data.foundedBas
      this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.data.regmoneyBas
      this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.data.legalBas
      this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = this.data.agentLevelBas
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgent = this.data.oneLevelAgentBas
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = this.data.oneLevelAgentNameBas
      this.formLabelAlign1.bscUserInfoAgentBasic.introduce = this.data.introduceBas
      this.formLabelAlign1.bscUserInfoAgentBasic.business = this.data.businessBas
      this.formLabelAlign1.bscUserInfoAgentBasic.achievement = this.data.achievementBas
      this.formLabelAlign1.bscUserInfoAgentBasic.resource = this.data.resourceBas
      this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = this.data.contactmobilephoneBas
      //this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = this.data.citystreetroomBas
      this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.data.streetroomBas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.data.phonenumberBas
      this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = this.data.iszhidanBas
      this.formLabelAlign1.bscUserInfoAgentBasic.remark = this.data.remark
      this.formLabelAlign1.bscUserInfoAgentBasic.agentType = this.data.agentTypeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName = this.data.associatedCompanyNameBas
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode = this.data.associatedCompanyCodeBas
      if (this.data.iszhidanBas == 1) {
        this.isZhiDan = true;
      }
      if(this.data.isExpandAuthorityBas == 1){
        this.isExpandAuthority = true
        this.isShowByHw = true;
      }else{
        this.isExpandAuthority = false
        this.isShowByHw = false;
      }
      this.formLabelAlign1.bscUserInfoAgentBank.vatCode = this.data.vatcodeBank
      this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = this.data.bankbranchcodeBank
      this.formLabelAlign1.bscUserInfoAgentBank.bankName = this.data.banknameBank
      this.formLabelAlign1.bscUserInfoAgentBank.accountHolderName = this.data.accountholdernameBank
      if (this.data.scaleBas !== undefined) {
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.email = this.data.emailBas
      this.formLabelAlign1.bscUserInfoAgentCompany.mailreceiver = this.data.mailreceiverCom
      this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone = this.data.receiverphoneCom
      this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = this.data.mailaddressCom
      this.formLabelAlign1.bscUserInfoAgentSell.auditMind1 = this.data.auditmind1Sell
      this.formLabelAlign1.bscUserInfoAgentSell.auditMind2 = this.data.auditmind2Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup = this.data.customergroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = this.data.customerassigngroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = this.data.customergroup2Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.data.customergroup3Sell
      this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = this.data.salesregionSell
      this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = this.data.contactcityBas
      this.formLabelAlign1.bscUserInfoAgentBasic.appellation = this.data.appellationBas
      this.formLabelAlign1.bscUserInfoAgentBasic.country = this.data.countryBas
      this.formLabelAlign1.bscUserInfoAgentBasic.region = this.data.regionBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCodeGeneral = this.data.companycodegeneralBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = this.data.companycodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = this.data.goodsCategoryBas
      this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.data.taxcodeBas
      this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = this.data.bankcountryBank
      this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = this.data.distributionchannelSell
      this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = this.data.salesgroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.data.customergroup3NotMainSell
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = this.data.currencycodeSell
      this.formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate = this.data.xkzEffectiveDateSell
      this.formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate = this.data.yyzzEffectiveDateSell
      this.formLabelAlign1.bscUserInfoAgentSell.inEmail = this.data.inEmailSell
      if (this.data.accountdistributegroupSell && this.data.accountdistributegroupSell != '') {
        this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = this.data.accountdistributegroupSell
      }
                //
                this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = this.data.haveThree6840Sell
                if(this.data.haveThree6840Sell == 1){
                    this.haveThree6840 = true
                }
                this.formLabelAlign1.bscUserInfoAgentSell.licenseNumber = this.data.licenseNumberSell
      this.formLabelAlign1.bscUserInfoAgentSell.have6840 = this.data.have6840Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have6854 = this.data.have6854Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have6858 = this.data.have6858Sell
      this.formLabelAlign1.bscUserInfoAgentSell.permit = this.data.permitSell
      if (this.data.agentTypeBas == '3') {
        this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = this.data.intcommercialtermsSell;
        this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = this.data.intcommercialterms2Sell;
      }
      if (this.data.have6840Sell == 1) {
        this.have6840 = true;
      }
      if (this.data.have6854Sell == 1) {
        this.have6854 = true;
      }
      if (this.data.have6858Sell == 1) {
        this.have6858 = true;
      }
      if (this.data.haveThree6840Sell == 1) {
          this.haveThree6840 = true;
      }
      let s = this.data.goodsCategoryBas;
      if(this.data.goodsCategoryBas != null && this.data.goodsCategoryBas != '' && typeof(this.data.goodsCategoryBas) != "undefined"){
        let s = this.data.goodsCategoryBas;
        this.getLianquns(s)
      }
      if(this.data.customergroup3Sell != null && this.data.customergroup3Sell != '' && typeof(this.data.customergroup3Sell) != "undefined"){
        var s1 = this.data.customergroup3Sell
        var m  = s1.split(',');
        if(m.length<=0){
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = ''
        }else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = m
          this.getQudao(this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3)
        }
      }

      if(this.data.customergroup3NotMainSell != null && this.data.customergroup3NotMainSell != '' && typeof(this.data.customergroup3NotMainSell) != "undefined") {
        var s2 = this.data.customergroup3NotMainSell
        var m = s2.split(',');
        if (m.length <= 0) {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = ''
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = m
          this.getQudaoNotMain(this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain)
        }
      }


    },
    getLianquns(s){
      var m  = s.split(',');
      if(m.length<=0){
        this.lianqunList = []
      }else {
        this.lianqunList = m
      }
    },
    showAgentList(value) {
      ss.UserService.selectAgentByName(value).then(rd=>{
        console.log(rd);
        this.oneAgentList = rd.msg;
      })
      this.isShowAllSelect = false
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
      this.lianqunList = [];
    },
    changeAgent(value){
      console.log(value)
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = value.customerName
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgent = value.usercode
      this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = value.salesRegion
      this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = value.salesGroup
      this.formLabelAlign1.bscUserInfoAgentSell.saleChannel = value.saleChannel
      this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = value.distributionChannel

      this.formLabelAlign1.bscUserInfoAgentSell.companyCode = value.companyCode
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = value.customerGroup3
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.data.customerGroup3NotMainSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = value.customerGroup2
      this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = value.accountDistributeGroup
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = value.goodsCategory
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = value.companyCode
      if(value.goodsCategory == ''){
        this.lianqunList = []
      }

      if(value.customerGroup3 != null && value.customerGroup3 != ''){
        let s = value.customerGroup3
        var m  = s.split(',');
        if(m.length<=0){
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = ''
        }else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = m
        }
      }

      if(value.customerGroup3NotMain != null && value.customerGroup3NotMain != ''){
        let s = value.customerGroup3NotMain
        var m  = s.split(',');
        if(m.length<=0){
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = ''
        }else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = m
        }
      }
      this.showLianqun(value)
      let s = value.goodsCategory
      if(s != null && s!='' && typeof(s) != "undefined"){
        this.getLianquns(s)
        this.lianqunOptions(s)
      }
      this.chflag++;
    },
    showLianqun(value){
      this.chflag++;
      if(value.goodsCategory == null || value.goodsCategory == '' || typeof(value.goodsCategory)=="undefined"){
        this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
        this.lianqunList = []
      }
      var lianqun = value.goodsCategory
      if(lianqun != null && lianqun != '' && typeof(lianqun)!="undefined"){

        if(lianqun.indexOf("X02") != -1 || lianqun.indexOf("X01") != -1
            ||lianqun.indexOf("X08") != -1 ||lianqun.indexOf("X09") != -1
            ||lianqun.indexOf("X10") != -1 ||lianqun.indexOf("X07") != -1
            ||lianqun.indexOf("X11") != -1){
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 1){
            this.ctLevel = '04'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 3){
            this.ctLevel = '04'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2){
            this.ctLevel = '04'
          }
        }else {
          this.ctLevel = ''
        }

        if(lianqun.indexOf("X05") != -1){
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 1){
            this.ND5Level = '04'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 3){
            this.ND5Level = '04'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2){
            this.ND5Level = '04'
          }
        }else {
          this.ND5Level = ''
        }

        if(lianqun.indexOf("X06") != -1){

          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 1){
            this.ND4Level = '04'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 3){
            this.ND4Level = '04'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2){
            this.ND4Level = '04'
          }
        }else {
          this.ND4Level = ''
        }

        if(lianqun.indexOf("X12") != -1){

          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 1){
            this.NA9Level = '04'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 3){
            this.NA9Level = '04'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2){
            this.NA9Level = '04'
          }
        }else {
          this.NA9Level = ''
        }
      }
    },
    changDealer(value){

      if(this.isZhiDan == true){
        if(value == 2){
          this.ctLevel = '04';
          this.chflag++;
        }else if(value == 3){
          this.ctLevel = '04';
          this.chflag++;
        }
      }else {
        if(value == 2){
          this.ctLevel = '05';
        }else if(value == 3){
          this.ctLevel = '02';
        }
      }
    },
    lianqunOptions(value){
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = value;
      if(this.isZhiDan == true){
        if(value.indexOf("X02") != -1 || value.indexOf("X01") != -1
            ||value.indexOf("X08") != -1 ||value.indexOf("X09") != -1
            ||value.indexOf("X10") != -1 ||value.indexOf("X07") != -1 ){
          this.ctLevel = '04'
        }else {
          this.ctLevel = ''
        }

        if(value.indexOf("X05") != -1){
          this.ND5Level = '04'
        }else {
          this.ND5Level = ''
        }

        if(value.indexOf("X06") != -1){
          this.ND4Level = '04'
        }else {
          this.ND4Level = ''
        }

        if(value.indexOf("X12") != -1){
          this.NA9Level = '04'
        }else {
          this.NA9Level = ''
        }
      }else {
        if(value.indexOf("X02") != -1 || value.indexOf("X01") != -1
            ||value.indexOf("X08") != -1 ||value.indexOf("X09") != -1
            ||value.indexOf("X10") != -1 ||value.indexOf("X07") != -1 ){
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 1){
            this.ctLevel = '01'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 3){
            this.ctLevel = '02'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2){
            this.ctLevel = '05'
          }
        }else {
          this.ctLevel = ''
        }
        if(value.indexOf("X05") != -1){
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 1){
            this.ND5Level = '01'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 3){
            this.ND5Level = '02'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2){
            this.ND5Level = '05'
          }
        }else {
          this.ND5Level = ''
        }

        if(value.indexOf("X06") != -1){

          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 1){
            this.ND4Level = '01'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 3){
            this.ND4Level = '02'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2){
            this.ND4Level = '05'
          }
        }else {
          this.ND4Level = ''
        }

        if(value.indexOf("X12") != -1){

          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 1){
            this.NA9Level = '01'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 3){
            this.NA9Level = '02'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2){
            this.NA9Level = '05'
          }
        }else {
          this.NA9Level = ''
        }
      }

      var jsonObj = this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory
      var jStr = '';
      for(var item in jsonObj){
        jStr += jsonObj[item]+",";
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = jStr.substring(0, jStr.lastIndexOf(','))
      this.ctSelect()
      this.ND4Select()
      this.ND5Select()
      this.ND6Select()
      this.NA9Select()
    },
    getQudao(value){
      var jsonObj = value
      var jStr = '';
      for(var item in jsonObj){
        jStr += jsonObj[item]+",";
      }
      this.qudaos = jStr.substring(0, jStr.lastIndexOf(','))
      this.chflag++;
    },
    getQudaoNotMain(value){
      console.log(value)
      var jsonObj = value
      var jStr = '';
      for(var item in jsonObj){
        jStr += jsonObj[item]+",";
        console.log(jsonObj[item])
      }
      this.qudaosNotMain = jStr.substring(0, jStr.lastIndexOf(','))
      this.chflag++;
    },
    hasInclude(arr = [],item){
      return arr.includes(item)
    },
    goBack() {
      this.$router.push({path: '/agent/agentCopy'})
    },
    insert(formName) {
      if(this.isExpandAuthority){
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '1';
      }else{
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '0';
      }
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.qudaos
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.qudaosNotMain
      var flag = 0;
      //非海外经销商注册
      if (this.isShowMassage === true) {
        for (var i = 0; i < this.index.length; i++) {
          this.ind = this.index[i];
          var form = formName + this.ind;
          // console.log(form)
          this.$refs[form].validate((valid) => {
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
        //海外经销商注册
      } else {
        var indlog = [];
        indlog = this.index1;
        if(this.isShowByHw == false) {
          indlog = ['c', 'd', 'i', 'f','1','2'];
        }
        console.log(indlog);
        console.log("------------------------------");
        for (var i = 0; i < indlog.length; i++) {
          this.ind = indlog[i];
          var form = formName + this.ind;
          console.log(form,"梁婕")
          this.$refs[form].validate((valid) => {
            console.log(valid,"/////////////");
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
      }
      if (flag !== 0) {
        return false;
      }
      // this.loading = true;
      if (this.agentType == '3' && this.formLabelAlign1.bscUserInfoAgentBasic.upload5 > 0) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      }else if (this.have2 === true && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
      } else if (this.have2 === false && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
      } else if (this.have2 === true && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === false && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
      } else if (this.agentType == '3'){
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      }

      if (this.agentType == '3') {
        if (this.isZhiDan) {
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '1';
          this.formLabelAlign1.levelMap['ct'] = '04';
          this.formLabelAlign1.levelMap['ND4'] = '04';
          this.formLabelAlign1.levelMap['ND5'] = '04';
          this.formLabelAlign1.levelMap['ND6'] = '04';
          this.formLabelAlign1.levelMap['NA9'] = '04';
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '0';
          this.formLabelAlign1.levelMap['ct'] = '01';
          this.formLabelAlign1.levelMap['ND4'] = '01';
          this.formLabelAlign1.levelMap['ND5'] = '01';
          this.formLabelAlign1.levelMap['ND6'] = '01';
          this.formLabelAlign1.levelMap['NA9'] = '01';
        }
      }

      if (this.agentType == '3') {
        if(!this.isExpandAuthority){
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.country;
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
        }
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone;
      console.log(this.formLabelAlign1,"//////////");
      if (this.have6858 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 0;
      }
      if (this.have6840 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 0;
      }
      if (this.have6854 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 0;
      }

      if (this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone && this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone.length > 16) {
        this.$msg.msge("联系人手机号过长！");
      } else if (this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber && this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber.length > 30) {
        this.$msg.msge("开票电话过长！");
      } else {
        if (this.agentType == '3') {
          ss.SignService.insertGYDls(this.formLabelAlign1).then(response => {
            this.loading = false;
            if (response.f) {
              // this.loading = false;
              this.$message({
                type: "success",
                message: response.msg
              });
              this.$router.push({path: '/agent/agentCopy'})
            } else {
              this.$message({
                type: "error",
                message: response.msg
              });
              this.loading = false;
            }
          })
        } else {
          ss.SignService.insertDls(this.formLabelAlign1).then(response => {
            this.loading = false;
            if (response.f) {
              // this.loading = false;
              this.$message({
                type: "success",
                message: response.msg
              });
              if (this.flag === '1' || this.flag === '3' || this.flag === '4') {
                this.$router.push({path: '/agent/agentCopy'})
              } else {
                this.$router.push({path: '/login'})
              }
            } else {
              this.$message({
                type: "error",
                message: response.msg
              });
              this.loading = false;
            }
          })
        }
      }
    },
    saveGYDls(formName) {
      if(this.isExpandAuthority){
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '1';
      }else{
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '0';
      }
      if (this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 == ''){
        this.$msg.msge("请输入客户名称！");
        return false;
      }
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.qudaos
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.qudaosNotMain
      if (this.agentType == '3' && this.formLabelAlign1.bscUserInfoAgentBasic.upload5 > 0) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      }else if (this.have2 === true && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
      } else if (this.have2 === false && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
      } else if (this.have2 === true && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === false && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
      }else if (this.agentType == '3'){
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      }

      if (this.agentType == '3') {
        if (this.isZhiDan) {
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '1';
          this.formLabelAlign1.levelMap['ct'] = '04';
          this.formLabelAlign1.levelMap['ND4'] = '04';
          this.formLabelAlign1.levelMap['ND5'] = '04';
          this.formLabelAlign1.levelMap['ND6'] = '04';
          this.formLabelAlign1.levelMap['NA9'] = '04';
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '0';
          this.formLabelAlign1.levelMap['ct'] = '01';
          this.formLabelAlign1.levelMap['ND4'] = '01';
          this.formLabelAlign1.levelMap['ND5'] = '01';
          this.formLabelAlign1.levelMap['ND6'] = '01';
          this.formLabelAlign1.levelMap['NA9'] = '01';
        }
      }

      if (this.agentType == '3') {
        if(!this.isExpandAuthority){
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.country;
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
        }
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone;
      console.log(this.formLabelAlign1,"//////////");
      if (this.have6858 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 0;
      }
      if (this.have6840 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 0;
      }
      if (this.have6854 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 0;
      }

      if (this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone && this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone.length > 16) {
        this.$msg.msge("联系人手机号过长！");
      } else if (this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber && this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber.length > 30) {
        this.$msg.msge("开票电话过长！");
      } else {
        if( !this.formLabelAlign1.bscUserInfo.fileId){
          this.formLabelAlign1.bscUserInfo.fileId = this.refid;
        }

        ss.SignService.saveGYDls(this.formLabelAlign1).then(response => {
          this.loading = false;
          if (response.f) {
            // this.loading = false;
            this.$message({
              type: "success",
              message: response.msg
            });
            this.$router.push({path: '/agent/agentCopy'})
          } else {
            this.$message({
              type: "error",
              message: response.msg
            });
            this.loading = false;
          }
        })
      }
    },
    go(index) {
      this.indx = index;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    showAssociationAgent(value){
      console.log('value',value);
      agentCopyService.getOverseasAgent(value).then(rd=>{
        console.log(rd);
        this.associatedCompanyList = rd.obj;
      })
    },
    changeAssociationAgent(value){
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName = value.username;
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode = value.usercode;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      });

            },
            toLogin() {
                this.$router.push({path: '/login'})
            },
            //公司代码改变回掉
            companyCodeChange(obj) {
                if (obj && obj.length > 0) {
                    let bool = false;
                    for (let item of obj) {
                        if (item.code == '9390') {
                            bool = true;
                        }else{
                            this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
                        }
                    }
                    if (bool) {
                        this.isShowAllSelect = true;//判断是否展示全部群连并checkbox
                        let s = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
                        s = s.split(',');
                        if (s && s.length > 0 && s[s.length - 1] == '9390') {
                            ss.Dictservice.listbycategory('YlGoods_category').then(res => {
                                let arr = []
                                for (let item of res) {
                                    arr.push(item.code)
                                }
                                this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = arr.toString() || '';
                            })
                        }

                    } else {
                        this.isShowAllSelect = false;//判断是否展示全部群连并checkbox
                    }
                } else {
                    this.isShowAllSelect = false;//判断是否展示全部群连并checkbox
                    this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
                }
            },
  },

  mounted(){
  this.flag = this.$route.query.index;

  if (this.flag === '2') {
    this.uploadflag = false;
    this.delflag = false;
    this.data = this.$route.query;
    // this.rules = {};
    this.checkDetail();
  } else if (this.flag === '3') {
    this.uploadflag = false;
    this.delflag = false;
    this.data = this.$route.query;
    // this.rules = {};
    this.checkDetail();
  }
  let str = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
  if (str && str.split(',').indexOf('9390') >= 0) {
    this.isShowAllSelect = true;//判断是否展示全部群连并checkbox
  }
}
}
</script>
<style scoped>
.imgBox {
  margin: 20px;
}

.bannerBox {
  width: 100%;
  margin: 0 auto;
}

.whiteBox {
  padding: 0.22rem 0.26rem;
  background-color: #ffffff;
}

.titles {
  font-size: 0.16rem;
  color: #0e75e9;
  position: relative;
  padding-left: 9px;
  border-left: 0.05rem solid #0e75e9;
  font-weight: bold;
}
</style>
<style>
.weekplandetail10 .h-formbLine .h-elformWrap-2{
  width: 50%!important;
}
.weekplandetail10 .h-formbLine .el-form-item.HAVES-2 .el-form-item__label {
  width: 10%;
}
    /deep/ .weekplandetail10 .h-formbLine .h-elformWrap-5{
  width: 39%!important;
  margin-left: 10%
}
/deep/ .weekplandetail10 .h-formbLine .h-elformWrap-5 .el-form-item__content {
  width: 90%;
}
    /deep/ .weekplandetail10 .h-formbLine .h-elformWrap-5{
        width: 39%!important;
        margin-left: 10%
        }
        /deep/ .weekplandetail10 .h-formbLine .h-elformWrap-5 .el-form-item__content {
        width: 90%;
        }

.weekplandetail10 .h-formbLine .el-form-item.HAVES-2 .el-form-item__content {
  width: 90%;
}

.weekplandetail10 .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 70%;
}

.weekplandetail10 .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 22.5%;
}

.h-formbLine .newBox .el-form-item__content {
  width: 77.5%;
}

.h-formbLine .newBox .el-form-item__label {
  width: 9.7%;
  text-align: right;
}

.passfollow {
  position: absolute;
  right: 0;
  bottom: 0.3rem;
  background-color: #2785e7;
  color: white;
}

.zhanghu .h-formbLine .el-form-item__label {
  width: 42%;
}

.signsign .h-formbLine .el-form-item__label {
  width: 39%;
}

.zhanghu .h-formbLine .el-form-item__content,
.signsign .h-formbLine .el-form-item__content {
  width: 52%;
}

.zhanghu .h-formbLine .h-elformWrap-2,
.signsign .h-formbLine .h-elformWrap-2 {
  width: 25%;
  padding-right: 0
}

.weekplandetail10 .h-formbLine .el-form-item__label {
  width: 48%;
}

.weekplandetail10 .h-formbLine .el-form-item__content {
  width: 52%;
}

.bannerBox .el-form-item__content {
  width: 85%;
}

.bannerBox .el-input__inner {
  border: none;
  border-bottom: 1px solid #DCDFE6;
}

.width .h-formbLine .el-form-item__content .el-select {
  width: 100%;
}

.signsign .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 0%;
}

.signsign .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 100%;
}

.gccolor .el-form-item__label {
  color: rgb(255, 36, 36);
}
.w-elformWrap {
  width: 100% !important;
}
.w-elformWrap .el-form-item__label {
  width: 11% !important;
}
.w-elformWrap .el-form-item__content {
  width: 89% !important;
}
</style>
